import React, { useState } from 'react';
import SiteHeader from '@/components/SiteHeader';
import SiteFooter from '@/components/SiteFooter';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Contact = () => {
  const sessionToken = localStorage.getItem('session_token');
  const isLoggedIn = !!sessionToken;

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSending, setIsSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.subject || !formData.message) {
      toast.error('Please fill in all fields');
      return;
    }

    if (!isLoggedIn && (!formData.name || !formData.email)) {
      toast.error('Please enter your name and email');
      return;
    }

    setIsSending(true);
    try {
      const headers = isLoggedIn
        ? { 'Authorization': `Bearer ${sessionToken}` }
        : { 'Content-Type': 'application/json' };

      await axios.post(`${API}/contact/send`, formData, { headers });
      
      toast.success("Message sent! We'll get back to you soon.");
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      console.error('Failed to send message:', error);
      // Fallback: open mailto link
      const mailto = `mailto:support@bragbox.ai?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(formData.message)}`;
      window.location.href = mailto;
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      <SiteHeader source="contact_nav" />

      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-2" style={{ fontFamily: 'Manrope', color: '#1F2A44' }}>
            Contact support
          </h1>
          <p className="text-gray-600">Have a question or issue? We usually respond within 24 hours.</p>
        </div>

        <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm">
          <form onSubmit={handleSubmit} className="space-y-6">
            {!isLoggedIn && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-2" style={{ color: 'var(--navy-900)' }}>Name</label>
                  <Input
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    placeholder="Your name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2" style={{ color: 'var(--navy-900)' }}>Email</label>
                  <Input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    placeholder="you@example.com"
                  />
                </div>
              </div>
            )}

            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: 'var(--navy-900)' }}>Subject</label>
              <Input
                value={formData.subject}
                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                placeholder="What can we help with?"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: 'var(--navy-900)' }}>Message</label>
              <Textarea
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                placeholder="Describe your issue or question in detail..."
                className="min-h-[180px]"
              />
            </div>

            <Button
              type="submit"
              disabled={isSending}
              className="w-full py-6 text-lg font-semibold rounded-xl"
              style={{ backgroundColor: 'var(--navy-900)', color: 'white' }}
            >
              {isSending ? 'Sending...' : 'Send Message'}
            </Button>
          </form>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            Or email us directly at{' '}
            <a href="mailto:support@bragbox.ai" className="font-medium underline" style={{ color: '#1F2A44' }}>
              support@bragbox.ai
            </a>
          </p>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
};

export default Contact;
